import { createAxiosInstance } from './http';

export const sendReport = async (data) => {
  const res = await createAxiosInstance().post('/report', data);
  return res.data;
};
